import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

import {
  ICarRemoveDefect,
  ICarRemoveImage,
  IComponentData,
  IComponentRequest,
  IInspectionBody,
  IInspectionRequest,
  IUpdateCarImageRequest,
} from '../../../models/requests/InspectionRequests';
import {
  IComponent,
  IInspectionItem,
  InspectionImages,
  IRemoveCarImage,
  ISegment,
  IStartInspection,
  IUpdateCarImage,
  IUpdateDefect,
} from '../../../models/response/InspectionResponse';
import { IPagination } from '../../../models/response/ResponseModel';
import { BaseQueryType } from '../../api';

export const fetchInspectionsList = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<IPagination<IInspectionItem[]>, IInspectionRequest>({
    query: (params) => {
      return {
        url: 'v1/inspection/',
        params,
      };
    },
  });
export const fetchInspectionsListByUser = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<IInspectionItem, string>({
    query: (slug) => `v1/inspection/${slug}/`,
  });

export const fetchSegments = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<ISegment[], string>({
    query: (inspection_slug) => `v1/inspection/${inspection_slug}/segment/`,
  });

export const patchStartInspection = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<IStartInspection, string>({
    query: (inspection_slug) => ({
      url: `v1/inspection/${inspection_slug}/start_inspection/`,
      method: 'PATCH',
    }),
  });

export const fetchImages = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<InspectionImages[], string>({
    query: (inspection_slug) => `v1/inspection/${inspection_slug}/imagetemplate/`,
  });

export const patchCarImage = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<IUpdateCarImage, IInspectionBody<IUpdateCarImageRequest>>({
    query: ({ slug, body }) => ({
      url: `v1/inspection/${slug}/add_image/`,
      body: body,
      method: 'PATCH',
    }),
  });

export const removeCarImage = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<IRemoveCarImage, ICarRemoveImage>({
    query: ({ slug, file_uuid }) => ({
      url: `v1/inspection/${slug}/remove_image/`,
      body: { file_uuid },
      method: 'DELETE',
    }),
  });

export const fetchComponents = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<IComponent[], IComponentRequest>({
    query: ({ inspection_slug, segment_slug }) =>
      `v1/inspection/${inspection_slug}/${segment_slug}/components/`,
  });

export const patchDefect = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<IUpdateDefect, IInspectionBody<IUpdateCarImageRequest>>({
    query: ({ slug, body }) => ({
      url: `v1/inspection/${slug}/add_defect/`,
      body: body,
      method: 'PATCH',
    }),
  });

export const removeDefect = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<void, IInspectionBody<ICarRemoveDefect>>({
    query: ({ slug, body }) => ({
      url: `v1/inspection/${slug}/remove_defect/`,
      body: body,
      method: 'DELETE',
    }),
  });

export const patchFinishInspection = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<void, string>({
    query: (inspection_slug) => ({
      url: `v1/inspection/${inspection_slug}/end_inspection/`,
      method: 'PATCH',
    }),
  });

export const patchComponentData = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<void, IInspectionBody<IComponentData>>({
    query: ({ slug, body }) => ({
      url: `v1/inspection/${slug}/component_data/`,
      body: body,
      method: 'PATCH',
    }),
  });
